import { createEnumFilter } from '@spotify/confidence-core-react';

import type { ResourceType } from '../../hooks/useResourceSearch';
import { ALL_TYPES, RESOURCE_TYPE_CONFIG_MAP } from './resourceTypeConfig';

const formatTypeLabel = (type: ResourceType): string =>
  RESOURCE_TYPE_CONFIG_MAP[type].pluralLabel;

export const RESOURCE_TYPE_FILTER = createEnumFilter({
  id: 'resourceType',
  label: 'Type',
  enum: ALL_TYPES,
  formatLabel: formatTypeLabel,
  query: () => '',
});
